module.exports = __webpack_public_path__ + "img/support-payment.588b7173.svg";